// Vendor imports
const Immutable = require('immutable')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const ImageUrlSizes = require('client-v2/common/records/image-url-sizes')
const { defaultReviver, keyedReviver } = require('client-v2/common/state/record-reviver')

class InterestModelRecord extends Immutable.Record({
  followersCount: Number(),
  'is_category': Boolean(),
  isFollowing: Boolean(),
  key: String(),
  name: String(),
  'profile_images': new Immutable.List(),
  'profile_image_urls': null,
  type: String(modelTypes.INTEREST)
}) {
  // No methods
}

InterestModelRecord.reviver = keyedReviver(InterestModelRecord, {
  'profile_images': defaultReviver,
  'profile_image_urls': ImageUrlSizes.reviver
})

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const { INTEREST_FOLLOWING_CHANGE_PENDING } = require('./actions')

  InterestModelRecord.propTypes = {
    followersCount: PropTypes.number,
    'is_category': PropTypes.bool,
    isFollowing: PropTypes.oneOf([ true, false, INTEREST_FOLLOWING_CHANGE_PENDING ]),
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    'profile_images': PropTypes.arrayOf(PropTypes.string),
    'profile_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
    type: PropTypes.oneOf([ modelTypes.INTEREST ]).isRequired
  }
}

module.exports = InterestModelRecord
